import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../component/menu/Header";
import SideMenu from "../component/menu/SideMenu";
import { constants } from "../constant/constants";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";
import { Spin, Tabs } from "antd";
import DinningPlace from "../component/table/DinningPlace";
import CustomLoader from "../component/menu/CustomLoader";
import TableStatusComponent from "../component/table/TableStatusComponent";
import LayoutHeaderComponent from "../component/table/LayoutHeaderComponent";
import "../styles/TabsStyle.css";

export default function RestaurantFloorPlan() {
  const navigate = useNavigate();
  const { user, networkCall, setNetworkCall, showNotification, isSuperAdmin } = useUserStore();
  const params = useParams();
  const { restaurantId, branchId } = params;

  const [tableLayoutLoading, setTableLayoutLoading] = useState(false);
  const [selectedTableIds, setSelectedTableIds] = useState([]);

  const BadgeComponent = ({ color, title, icon }) => {
    const dotStyle = {
      backgroundColor: color
    }
    return (
      <div className="flex flex-row rounded-[6px] items-center px-[16px] py-[6px] gap-4" style={dotStyle}>
        <div className="text-[16px] font-bold">{title}</div>
        <img src={icon} className="w-[20px] h-[30px]" />
      </div>
    )
  }

  const [tabItems, setTabItems] = useState([]);
  const [summary, setSummary] = useState({
    available: 0,
    onDine: 0,
    occupied: 0
  });
  /*Menu options*/

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /*API call functions*/
  async function getFloorAndTableLayout(params) {
    const token = user.token.token;
    setNetworkCall(true);

    try {
      const res = await ApiService.GET_FLOOR_AND_TABLE_LAYOUT(params, token);
      if (!res || res.code !== 200) {
        showNotification(res?.message || "Failed to fetch restaurant branches");
        return;
      }

      const { payload } = res;
      if (payload.record) {
        processFloorLayouts(payload.record.floors);
        setSummary(payload.record.statusSummary);
      }
    } catch (err) {
      showNotification(err?.response?.data?.message || "Something went wrong");
    } finally {
      setNetworkCall(false);
    }
  }
  /*API call functions*/

  /*Helper functions*/
  function processFloorLayouts(floors) {
    const floorTabItems = floors.map(item => {
      return {
        place_id: item.id,
        label: item.name,
        key: item.id,
        children: <DinningPlace
          restaurantId={branchId}
          floorPlanId={item.id}
          allowMultiSelect={false}
          tableArray={item.tables}
          onUpdateSelectedTable={updatedSelectedTableIds} />,
      }
    })
    setTabItems(floorTabItems);
  }

  async function getInitialRecords() {
    const params = {
      restaurantId: branchId
    };
    await getFloorAndTableLayout(params);
  }

  useEffect(() => {
    async function fetchData() {
      await getInitialRecords()
    }
    fetchData()
  }, [])

  const updatedSelectedTableIds = (updatedTableIds) => {
    setSelectedTableIds(updatedTableIds)
  }
  /*Helper functions*/

  return (
    <section>
      <div className="flex flex-col bg-[#e5e7eb] min-h-screen">
        {/* {contextHolder} */}
        {/* <CustomLoader /> */}
        <Header title={""} menu={constants.SUPER_MENU.RESTAURANT} currentMenuKey={'T_51_S_51'} />
        <CustomLoader />
        <div className="flex flex-row bg-prewhite">
          <SideMenu
            title={`McDonalds Food Chain`}
            menu={constants.SUPER_MENU.RESTAURANT}
          />
          <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[80px]">
            <div className="flex flex-col w-full">
              <div className="flex flex-col">
                {tableLayoutLoading ? (
                  <div className="h-[70vh] flex items-center justify-center">
                    <Spin size="large" />
                  </div>
                ) : (
                  <div className="flex flex-col bg-[#FAFAFA]">
                    <LayoutHeaderComponent restaurantId={restaurantId} branchId={branchId} />
                    <div className="flex flex-col bg-white p-[16px]">
                      <div className="flex flex-row justify-between items-center ">
                        <div className="flex flex-row gap-[24px] flex-start">
                          <TableStatusComponent color="#73BD6E" status="Available" count={summary.available} />
                          <TableStatusComponent color="#FFACA1" status="On Dine" count={summary.onDine} />
                          <TableStatusComponent color="#FFEA00" status="Occupied" count={summary.occupied} />
                        </div>
                        <div className="flex flex-row gap-[24px]">
                          {/*<BadgeComponent color="#97F8EC" title="Reserve Table" icon="/images/icons/beenhere.svg"/>*/}
                          <BadgeComponent color="#FFD700" title="Takeout" icon="/images/icons/take-away-svgrepo-com.svg" />
                        </div>
                      </div>
                    </div>
                    <div className="w-full h-[100vh] bg-[#FAFAFA]">
                      {
                        (!networkCall && tabItems.length === 0) ? (
                          <div className="w-full h-[70vh] flex items-center justify-center">
                            <div className="text-center">
                              <h1 className="text-2xl font-semibold leading-[44px] mb-5">No tables found.<br />Please contact TableTap Authority to add floor plan.</h1>
                              <button className="bg-[#2EC114] text-white h-[44px] px-2.5 rounded-lg font-medium"
                                onClick={() => navigate(`/restaurants/${restaurantId}/branch/${branchId}/floor-plan/add`)}>
                                Add Floor
                              </button>
                            </div>
                          </div>
                        ) : (
                          <Tabs
                            defaultActiveKey="1"
                            type="card"
                            size="middle"
                            style={{ marginBottom: 32 }}
                            items={tabItems}
                            className="h-full custom-tabs"
                          />
                        )
                      }
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}